export default __webpack_public_path__ + "static/media/us.912cb4a8.svg";